import { gql } from "@/services/httpAdapter";

export const onCreateTrainingItem = gql`
	subscription onCreateTrainingItem($commissionCycleId: String) {
		onCreateTrainingItem(commissionCycleId: $commissionCycleId) {
			_id
			commissionCycleId
			createdAt
			createdBy {
				_id
				fullName
			}
			items {
				_id
				createdAt
				createdBy {
					_id
					fullName
				}
				effectiveDateFrom
				effectiveDateTo
				pay {
					input
					value
				}
				updatedAt
				updatedBy {
					_id
					fullName
				}
				userId {
					_id
					fullName
					employeeId
				}
			}
			updatedAt
			updatedBy {
				_id
				fullName
			}
		}
	}
`;

export const onUpdateTrainingItem = gql`
	subscription onUpdateTrainingItem($commissionCycleId: String) {
		onUpdateTrainingItem(commissionCycleId: $commissionCycleId) {
			_id
			commissionCycleId
			createdAt
			createdBy {
				_id
				fullName
			}
			items {
				_id
				createdAt
				createdBy {
					_id
					fullName
				}
				effectiveDateFrom
				effectiveDateTo
				pay {
					input
					value
				}
				updatedAt
				updatedBy {
					_id
					fullName
				}
				userId {
					_id
					fullName
					employeeId
				}
			}
			updatedAt
			updatedBy {
				_id
				fullName
			}
		}
	}
`;

export const onDeleteTrainingItems = gql`
	subscription onDeleteTrainingItems($commissionCycleId: String) {
		onDeleteTrainingItems(commissionCycleId: $commissionCycleId) {
			_id
			commissionCycleId
			createdAt
			createdBy {
				_id
				fullName
			}
			items {
				_id
				createdAt
				createdBy {
					_id
					fullName
				}
				effectiveDateFrom
				effectiveDateTo
				pay {
					input
					value
				}
				updatedAt
				updatedBy {
					_id
					fullName
				}
				userId {
					_id
					fullName
					employeeId
				}
			}
			updatedAt
			updatedBy {
				_id
				fullName
			}
		}
	}
`;
